import { render, staticRenderFns } from "./tit-wrap-tertiary.vue?vue&type=template&id=4092f82e&scoped=true&"
import script from "./tit-wrap-tertiary.vue?vue&type=script&lang=js&"
export * from "./tit-wrap-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4092f82e",
  null
  
)

export default component.exports